// @flow

export const CATEGORY_API_CONVERTER = {
  hold_bag: "holdBag",
  hand_bag: "handBag",
  personal_item: "personalItem",
  cabin_bag: "cabinBag",
}
export const CONDITION_API_CONVERTER = {
  passenger_groups: "passengerGroups",
  is_priority: "isPriority",
}
